import ReleveInformation from "@/pages/questions/liste-questions/components/releve-information";
import SelectContract from "@/components/shared/select-contract";
import AvisEcheance from "@/pages/questions/liste-questions/components/avis-echeance";
import { Link } from "react-router-dom";
import RequestDocument from "@/pages/questions/liste-questions/components/request-document";
import { Button } from '@/components/ui/button';

export const getComponentByType = (type?: string | null) => {
    switch(type) {
        case 'RI':
            return <div className="my-4">
                <SelectContract>
                    <ReleveInformation />
                </SelectContract>
            </div>
        case 'ECHEANCE':
            return <div>
                <SelectContract>
                    <AvisEcheance />
                </SelectContract>
            </div>
        case 'DP':
            return <RequestDocument title={'Je demande mon contrat'} type='dispositions_particulieres'/>
        case 'RIB':
            return <div className="text-center">
                <Button asChild className="cursor-pointer text-white no-underline">
                    <Link to="/mon-profil/je-change-mes-informations-bancaires">Changer mon RIB</Link>
                </Button>
            </div>
        case 'CARTE_VERTE':
            return <div className="text-center">
                <Button asChild className="cursor-pointer text-white no-underline">
                    <Link to="/mes-documents">Mes documents</Link>
                </Button>
            </div>
        case 'DECLA_SINISTRE':
            return <div className="text-center">
                <Button asChild className="cursor-pointer text-white no-underline">
                    <Link to="/mes-sinistres/je-declare-un-sinistre">Je déclare un sinistre</Link>
                </Button>
            </div>
        default:
            return ''
    }
}
